var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 16,
    viewBox: "0 0 16 16",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 14.545h16v1.455h-16z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m0 0h8v1.455h-8z",
    transform: "matrix(.8660254 -.5 .5 .8660254 .174 4.009)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m5.455 21.568v-11.636l-1.455-.182v11.818z",
    transform: "translate(-4 -5.568)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m0 0h8v1.455h-8z",
    transform: "matrix(-.8660254 -.5 .5 -.8660254 15.101 5.279)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m24 21.568v-11.636l1.455-.182v11.818z",
    transform: "translate(-9.455 -5.568)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m7.091 0h1.818v1.273h-1.818z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m4 9.687.175-.167 1.28.895z",
    transform: "translate(-4 -5.505)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m25.28 9.52.175.167-1.455.728z",
    transform: "translate(-9.455 -5.505)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m11.636 7.273h1.455v8.364h-1.455z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m7.273 7.273h1.455v8.364h-1.455z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m0 0h1.455v5.818h-1.455z",
    transform: "matrix(0 1 -1 0 13.091 7.273)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m0 0h1.455v2.909h-1.455z",
    transform: "matrix(0 1 -1 0 5.818 8.727)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m0 0h1.455v2.909h-1.455z",
    transform: "matrix(0 1 -1 0 5.818 11.636)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.2314adbb.svg";
export { ForwardRef as ReactComponent };